import Dashboard from "../../components/UserDashboard/Dashboard";

export default function UserDashboardPage() {
    return(
        <Dashboard />
    );
}